// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemStandingsGetBody = {
  poolId: string;
  scope: "contest" | "season";
  contestId?: string | null;
  seasonId?: string | null;
};

export type typePickemStandingsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    scope: "contest" | "season";
    label: string;
    rows: {
      userId: string;
      displayName: string;
      photoUrl?: string | null;
      rank: number;
      points: number;
      wins: number;
      losses: number;
      pushes: number;
      titles: number;
      roundsPlayed: number;
      isViewer: boolean;
    }[];
    options: {
      contests: { contestId: string; name: string }[];
      seasons: { seasonId: string; label: string }[];
    };
  };
};

export type typePickemStandingsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemStandingsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemStandingsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemStandingsGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    scope: { type: "string", enum: ["contest", "season"] },
    contestId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    seasonId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "scope"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemStandingsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemStandingsGetBody);
  }

  return async function postPickemStandingsGet(
    payload: typePickemStandingsGetBody,
  ): Promise<
    typePickemStandingsGetOutput200 | typePickemStandingsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemStandingsGet" failed before calling the network. #671d6cade026`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#671d6cade026" },
        },
        data: null,
      } as typePickemStandingsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/standings-get`,
      httpMethod: "POST",
      options,
    })) as typePickemStandingsGetOutput200 | typePickemStandingsGetOutput400;
  };
}
